/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { findOne } from '@/js/utils/dom'

/**
 * Fill the input referenced by `data-password-target` with a 12-char random
 * alphanumeric password.
 *
 * @type {Listener}
 */
export default {
    selector: '.generate-password',
    connect(element) {
        const onClick = (e) => {
            e.preventDefault()

            const targetSelector = element.dataset.passwordTarget
            if (!targetSelector) {
                return
            }

            const input = findOne(targetSelector)
            if (!input) {
                return
            }

            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
            const array = new Uint32Array(12)
            crypto.getRandomValues(array)
            input.value = Array.from(array, (n) => chars[n % chars.length]).join('')
        }

        element.addEventListener('click', onClick)

        return () => element.removeEventListener('click', onClick)
    },
}
